import { Injectable } from '@angular/core';
import {FormbirdInjectorService} from '../injector/formbird-injector.service';
declare const angular: any;

@Injectable({
  providedIn: 'root'
})
export class UnsavedDocumentService {
  ajsService: any;

  constructor(private injector: FormbirdInjectorService) {
    this.ajsService = injector.get('UnsavedDocumentService');
  }

  setDocument(unsavedDocumentListId, document) {
    return this.ajsService.setDocument(unsavedDocumentListId, document);
  }

  setTemplate(unsavedDocumentListId, documentId, template) {
    return this.ajsService.setTemplate(unsavedDocumentListId, documentId, template);
  }

  removeDocumentList(unsavedDocumentListId) {
    return this.ajsService.removeDocumentList(unsavedDocumentListId);
  }

  /**
   * create a new unsaved document list. The unsaved document list is a list of documents that will be saved in a single
   * operation. This allows saving of documents independently of the nav bar save button. Eg. If you open up a dialog with a
   * template with a child doc then you need to save several documents on dialog close without saving the main document loaded
   * in the form. We can't put parameters in the save function to handle special cases like whether the save is for a dialog
   * because we would have to keep adding more special cases for saving from different locations.
   */
  createUnsavedDocumentList(name, existingUnsavedDocumentListId?) {
    return this.ajsService.createUnsavedDocumentList(name, existingUnsavedDocumentListId);
  }

  updateDocumentListInfo(documentInfo, unsavedDocumentListId) {
    this.ajsService.updateDocumentListInfo(documentInfo, unsavedDocumentListId);
  }

}
